// @owners { team: patient-health }
import { Column, Row } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { Text, palette, spacing } from '@alto/pocky';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import styledNative from 'styled-components/native';
import { type Medication } from '~shared/features/my-meds/types';
import { MedListRowContainer } from './MedListRow';
import MedListRow from './MedListRowContainer';

type Props = {
  readonly searchOptions: Record<string, Medication>;
  readonly searchTerm: string | undefined;
  readonly fireMedicationsSearchedAnalyticsEvent: (searchTerm: string) => void;
};

const StyledCol = styled(Column).attrs({
  stretchItems: true,
})`
  padding-left: 0;
  padding-right: 0;
`;

const MedListContainer = styledNative(Row)`
  border-radius: ${spacing.borderRadius};
  flex-direction: column;
`;

const NoResultsRow = styled(MedListRowContainer)<{ children: React.ReactNode }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const IconContainer = styled.div`
  margin-bottom: 1rem;
`;

const ExclamationIcon = styled(FontAwesomeIcon)`
  left: -15%;
  position: absolute;
  top: -20%;
`;

// @ts-expect-error TS(7006): Parameter 'searchOptions' implicitly has an 'any' type.
function medications(searchOptions, searchTerm) {
  return Object.keys(searchOptions).reduce((meds, option) => {
    if (option.includes(searchTerm)) {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parameter of type 'never'.
      meds.push(searchOptions[option]);
    }

    return meds;
  }, []);
}

export default class MedListSearchResults extends React.PureComponent<Props> {
  componentDidMount() {
    const { searchTerm, fireMedicationsSearchedAnalyticsEvent } = this.props;
    fireMedicationsSearchedAnalyticsEvent(searchTerm || '');
  }
  componentDidUpdate(prevProps: Readonly<Props>) {
    const { searchTerm: prevSearchTerm } = prevProps;
    const { searchTerm, fireMedicationsSearchedAnalyticsEvent } = this.props;
    if (prevSearchTerm !== searchTerm) {
      fireMedicationsSearchedAnalyticsEvent(searchTerm || '');
    }
  }
  componentWillUnmount() {
    const { fireMedicationsSearchedAnalyticsEvent } = this.props;
    fireMedicationsSearchedAnalyticsEvent('');
  }

  isExactMatch(medication: Medication) {
    const { searchTerm } = this.props;

    return searchTerm === medication.prescriptions[0].rx_number;
  }

  render() {
    const { searchOptions, searchTerm } = this.props;

    const matchingMedications = medications(searchOptions, searchTerm?.toLowerCase());

    return (
      <MedListContainer>
        <StyledCol>
          {matchingMedications.length > 0 ? (
            matchingMedications.map((medication) => (
              <MedListRow
                // @ts-expect-error TS(2339): Property 'prescriptions' does not exist on type 'never'.
                key={medication.prescriptions[0].rx_number}
                medication={medication}
                initShowDetail={this.isExactMatch(medication)}
              />
            ))
          ) : (
            <NoResultsRow>
              <IconContainer className="fa-stack">
                <FontAwesomeIcon
                  className="fa-stack-2x"
                  color={palette.grey2}
                  icon={faSearch}
                />

                <ExclamationIcon
                  className="fa-stack-1x"
                  color={palette.grey1}
                  icon={faExclamation}
                  size="xs"
                />
              </IconContainer>

              <Text>Your search did not match any medications.</Text>
            </NoResultsRow>
          )}
        </StyledCol>
      </MedListContainer>
    );
  }
}
